import { createSlice } from '@reduxjs/toolkit';
import { createOrder, verifyTransaction } from '../thunks/payments';

const initialState = {
  order: {},
  paymentSuccess: false,
  fetching: false,
  fetchError: '',
  saving: false,
  saveError: '',
};

export const paymentsSlice = createSlice({
  name: 'payments',
  initialState,
  extraReducers: {
    [createOrder.pending]: (state) => {
      state.fetching = true;
    },
    [createOrder.fulfilled]: (state, action) => {
      state.fetching = false;
      state.order = action.payload;
    },
    [createOrder.rejected]: (state) => {
      state.fetching = false;
    },
    [verifyTransaction.pending]: (state) => {
      state.fetching = true;
    },
    [verifyTransaction.fulfilled]: (state) => {
      state.fetching = false;
      state.paymentSuccess = true;
    },
    [verifyTransaction.rejected]: (state) => {
      state.fetching = false;
      state.paymentSuccess = false;
    },
  },
});
